$(document).ready(function(){


    const checkboxGroups = document.querySelectorAll('.filter-group-display');

    checkboxGroups.forEach(group => {
        const checkboxes = group.querySelectorAll('.filter-group-display__list-item input[type="checkbox"]');
        const applyButton = group.querySelector('.filter-group-display__submit input[type="submit"]');
        const resetButton = group.querySelector('.filter-group-display__header-reset');

        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', function() {
                if (this.checked) {
                    // Trigger Apply button within the same group
                    applyButton.click();
                } else {
                    // Trigger Reset button within the same group
                    resetButton.click();
                }
            });
        });
    });
  
});